import { useState, useEffect } from 'react';

const useResponsive = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(false);
    // console.log("||||ALERT",isMobile);
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, [breakpoint]);

    return isMobile;
};

export default useResponsive;